/* eslint-disable */
export default {
  logged: 'Geregistreerd',
  unlogged: 'Onbewerkt',
  faxNotSupported: 'Het loggen van faxen wordt niet ondersteund.',
} as const;

// @key: @#@"logged"@#@ @source: @#@"Logged"@#@
// @key: @#@"unlogged"@#@ @source: @#@"Unworked"@#@
// @key: @#@"faxNotSupported"@#@ @source: @#@"To log fax is not supported."@#@
